module.exports = __webpack_public_path__ + "static/assets/563e9cf9e28b483c7c515fb438412311.gif";